require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-cabin-training-centre-qatar.json") })
        }
      }, "path---projecten-cabin-training-centre-qatar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-cabin-training-centre-qatar!./.cache/json/projecten-cabin-training-centre-qatar.json
// module id = 406
// module chunks = 231608221292675